var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiversityHands(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 240,
    height: 228,
    viewBox: "0 0 240 228",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M17.9184 56.7766C6.7152 82.5999 16.4784 112.194 40.4832 128.318C56.5824 139.135 81.1152 147.698 117.73 144.693C224.098 135.956 234.264 93.7902 223.234 60.949C212.203 28.1079 184.262 15.4722 127.642 16.1698C82.9632 16.7216 34.2576 19.1065 17.9184 56.7721V56.7766Z",
    fill: "#E8ECF0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M227.966 153.667H12.0385V211.849H227.966V153.667Z",
    fill: "#E8ECF0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M227.966 153.667H12.0385V162.135H227.966V153.667Z",
    fill: "#C9D3DB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M87.7201 153.617L76.4401 95.6824C76.4401 95.6824 66.6193 75.5227 78.6241 64.8112C90.6289 54.0952 87.7201 85.3951 95.3569 85.126C102.994 84.857 105.543 73.1469 109.181 79.6951C112.819 86.2387 97.5409 95.687 97.5409 95.687L115.507 153.622H87.7153L87.7201 153.617Z",
    fill: "#F4A28C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M82.6274 153.617L75.3506 111.109L106.272 108.45L120.096 153.617H82.6274Z",
    fill: "#00AB50"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M140.822 153.617L130.877 86.2343C130.877 86.2343 123.657 80.9994 122.64 74.8343C122.126 71.7289 125.793 69.5264 128.525 71.3003C131.342 73.1334 134.933 74.3327 136.694 70.3335C139.848 63.1926 134.006 53.5117 143.222 52.3626C152.438 51.2089 161.673 71.4872 145.665 84.3875L163.857 153.613H140.817L140.822 153.617Z",
    fill: "#774600"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M135.245 153.617L131.122 124.251L160.224 122.869L168.23 153.617H135.245Z",
    fill: "#009D93"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M133.262 124.151L131.122 110.658L151.997 108.451L155.837 123.079L133.262 124.151Z",
    fill: "#009D93"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.46,
    d: "M133.262 124.151L131.122 110.658L151.997 108.451L155.837 123.079L133.262 124.151Z",
    fill: "white"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M40.296 153.804L28.9824 95.678C28.9824 95.678 19.1616 75.5183 31.1664 64.8068C43.1712 54.0908 40.2624 85.3907 47.8992 85.1216C55.536 84.8526 58.0848 73.1425 61.7232 79.6907C65.3616 86.2343 50.0832 95.6826 50.0832 95.6826L68.1119 153.809H40.3008L40.296 153.804Z",
    fill: "#CE8172"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M53.0822 96.729L27.3236 100.509L28.7377 109.206L54.4963 105.427L53.0822 96.729Z",
    fill: "#24285B"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6383 108.97C40.1032 108.97 42.9119 106.302 42.9119 103.01C42.9119 99.7189 40.1032 97.0505 36.6383 97.0505C33.1735 97.0505 30.3647 99.7189 30.3647 103.01C30.3647 106.302 33.1735 108.97 36.6383 108.97Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M185.942 153.617L178.91 89.2301C178.91 89.2301 170.179 86.0062 170.424 80.0143C170.669 74.0225 175.762 66.1884 182.794 66.8815C189.826 67.5746 193.19 68.7374 193.92 60.4428C194.65 52.1482 206.198 53.7487 202.925 62.5723C201.691 65.8966 199.162 77.5291 197.707 84.433C196.982 87.8803 197.026 91.428 197.832 94.8571L211.656 153.622H185.947L185.942 153.617Z",
    fill: "#F4A28C"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M191.894 72.9463C191.894 72.9463 196.853 78.9746 191.035 85.541C185.218 92.1074 193.867 153.613 193.867 153.613H185.947L178.915 89.2255L191.899 72.9463H191.894Z",
    fill: "#29333D"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M183.437 87.3605C181.291 89.3851 177.984 89.7773 175.373 88.3272C172.339 86.64 168.951 83.945 169.085 80.3563C169.33 73.9039 175.954 65.0621 182.789 66.5304C189.624 67.9987 193.704 71.1406 191.275 77.2464C189.85 80.8397 186.197 84.7476 183.432 87.3605H183.437Z",
    fill: "#F4A28C"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M183.514 153.617L180.533 135.541L210.197 134.392L214.805 153.617H183.514Z",
    fill: "#00AB50"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiversityHands);
export default __webpack_public_path__ + "static/media/diversity-hands.8e7c6c501374f7fc026950c148fc89b7.svg";
export { ForwardRef as ReactComponent };